import { AsideComponent } from './components/aside/aside.component';
import { HeaderComponent } from './components/header/header.component';
import { LayoutComponent } from './layout.component';
import { ScriptsInitComponent } from './init/scripts-init/scripts-init.component';
import { TopbarComponent } from './components/topbar/topbar.component';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PagesRoutingModule } from './page-routing.module';
import { SafeHTMLModule } from '../core/modules/safe-html.module';

import { MatIconModule } from '@angular/material/icon';
import { DirectivesModule } from '../core/directives/directives.module';
import { TenantStatisticsComponent } from 'src/app/main/dashboard/tenant-statistics/tenant-statistics.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CoachMarksResetModalComponent } from '../components/coach-marks-reset-modal/coach-marks-reset-modal.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AsideComponent,
    HeaderComponent,
    LayoutComponent,
    ScriptsInitComponent,
    TopbarComponent,
    TenantStatisticsComponent,
    CoachMarksResetModalComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    PagesRoutingModule,
    SafeHTMLModule,
    MatIconModule,
    DirectivesModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
  exports: [LayoutComponent]
})
export class LayoutModule { }
